import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import qs from "qs";
import "../static/js/flexible";
import publicJS from "../static/js/public.js";

Vue.use(publicJS);

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;

Vue.config.productionTip = false;

let resizeTimer = null;
function renderResize() {
  store.commit("setIstrue", false);
  if (resizeTimer) clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    // 判断横竖屏
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;
    // 横屏 10  竖屏 1
    store.commit("setScreen", width > height ? 10 : 1);
    store.commit("setIstrue", true);
  }, 300);
  // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
}

let isAddresize = false;
router.beforeEach((to, from, next) => {
  if (to.path == "/base-login") {
    if (isAddresize) {
      window.removeEventListener("resize", renderResize);
      isAddresize = false;
    }
  } else {
    if (!isAddresize) {
      window.addEventListener("resize", renderResize);
      isAddresize = true;
    }
  }
  next()
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
